import clsx from 'clsx'
import { Portal } from 'components/utility/portal'
import React, { useEffect, useRef, useState } from 'react'

function CompanyFormModal({ open = false, onClose = () => {}, children }) {
  const [show, setShow] = useState(open)
  const overlayRef = useRef(null)

  useEffect(() => {
    setShow(open)
  }, [open])

  useEffect(() => {
    document.body.classList.toggle('overlay-activated', show)
  }, [show])

  const handleClose = () => {
    setShow(false)
    onClose()
  }

  return (
    <>
      <Portal>
        <div className={clsx('company-form-modal-overlay', show && 'show')}>
          <div ref={overlayRef}>{children}</div>
        </div>
      </Portal>
    </>
  )
}

export default CompanyFormModal
